<div class="box-resp">
  <ng-container *ngFor="let item of HTML_ArrayHomeScreenElement">
    <mat-card *ngIf="item.visible" (click)="item.onClickEventFunc()" [ngClass]="getNgClassStyleColor">
      <mat-card-title>{{ item.title | translate }}</mat-card-title>
      <div class="home-img">
          <img mat-card-image [src]="item.imageSrc" alt="{{item.title}}">
      </div>
      <mat-card-content>{{item.content | translate}}</mat-card-content>
      <mat-card-actions></mat-card-actions>
    </mat-card>
  </ng-container>
</div>
